import { render, staticRenderFns } from "./IntField.vue?vue&type=template&id=9fb49504&scoped=true&"
import script from "./IntField.vue?vue&type=script&lang=js&"
export * from "./IntField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb49504",
  null
  
)

export default component.exports